//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
let d=[[[0,"Accuracy",1,0],[0,"ColorSaturation",1,0],[0,"Image",1,"Display.Image",0],[0,"ImageBlur",1,0],[0,"ImageFilename",1,0],[0,"ImageRotation",1,0],[0,"ImageType",1,0],[0,"ImageUpVector",1,"Direction",0],[0,"ImageUpVectorType",1,0],[0,"Intensity",1,0],[0,"LwrtAngle",1,0],[0,"LwrtIntensity",1,0],[0,"LwrtQuality",1,0],[0,"ShadowSoftness",1,0],[0,"ShadowType",1,0],[0,"UseImageBasedLighting",1,0],[0,"UseLightsForShadowCatcherInHqi",1,0],[0,"UseLightsForShadowCatcherInLwrt",1,0],[0,"UseLwrtImageBasedLighting",1,0]],[[["view","update_display"],"CommitAndDisplay",{},2,0]],[]];
SPLM.Display.ImageBasedLighting = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.ImageBasedLighting";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.ImageBasedLighting.ImagesType = Object.freeze({
    "Background" : "Background", "Stage" : "Stage", "UserDefined" : "UserDefined", "LightingOnly" : "LightingOnly"});

SPLM.Display.ImageBasedLighting.ShadowsType = Object.freeze({
    "None" : "None", "SoftEdged" : "SoftEdged", "HardEdged" : "HardEdged", "TranslucentHard" : "TranslucentHard"});

SPLM.Display.ImageBasedLighting.ImageBlurType = Object.freeze({
    "None" : "None", "Low" : "Low", "Medium" : "Medium", "High" : "High"});

SPLM.Display.ImageBasedLighting.ImageUpVectorTypes = Object.freeze({
    "AlignWithFloorPlane" : "AlignWithFloorPlane", "UserDefined" : "UserDefined"});

export default SPLM;